import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import ScrollToTop from '@/components/base/ScrollToTop';
import {
  HeroSection,
  LoginGuideSection,
  FeaturesSection,
  StatsSection,
  CategoryNavSection,
  ArticlePreviewSection,
  FAQSection,
  CTASection,
} from './components/HomeSections';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '众赢国际',
    url: 'https://zysecure.github.io',
    description: '众赢国际是专业可靠的综合性金融服务平台，提供安全便捷的投资交易服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-xxx-xxxx',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '众赢国际',
    url: 'https://zysecure.github.io',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://zysecure.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '众赢国际网页版登录入口在哪里？', acceptedAnswer: { '@type': 'Answer', text: '众赢国际网页版登录入口位于官方网站首页右上角，点击"登录"按钮即可进入登录页面。' } },
      { '@type': 'Question', name: '忘记众赢国际登录密码怎么办？', acceptedAnswer: { '@type': 'Answer', text: '在登录页面点击"忘记密码"，输入注册手机号或邮箱接收验证码，验证身份后即可重新设置密码。' } },
      { '@type': 'Question', name: '众赢国际平台是否安全可靠？', acceptedAnswer: { '@type': 'Answer', text: '众赢国际平台采用银行级加密技术，用户资金与平台运营资金完全隔离，并设有专项风险准备金。' } },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="众赢国际网页版登录入口 | 官方登录地址指引 - 众赢国际官网"
        description="找不到众赢国际网页版登录入口？本页提供众赢国际最新官方登录地址、网页版入口访问指南及常见登录问题解决方法，帮助用户快速找到正确登录页面，安全顺畅进入众赢国际平台账户。"
        keywords="众赢国际网页版登录入口,众赢国际登录地址,众赢国际官网入口,众赢国际网页版,众赢国际登录方法,众赢国际平台登录,众赢国际官方入口"
        canonicalUrl="https://zysecure.github.io"
      />

      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <LoginGuideSection />
        <FeaturesSection />
        <StatsSection />
        <CategoryNavSection />
        <ArticlePreviewSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}